import serviceProfile from "../../services/profile";
import * as constant from "./constant";

export function setLoading(payload) {
  return { type: constant.LOADING, payload: payload };
}

export function setProfile(payload) {
  return { type: constant.PROFILE, payload: payload };
}

export function setProfileResponse(payload) {
  return { type: constant.PROFILE_RESPONSE, payload: payload };
}

export function setDeleteAccountResponse(payload) {
  return { type: constant.DELETE_ACCOUNT_RESPONSE, payload: payload };
}

export function getProfile() {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceProfile.getProfile();
      dispatch(setProfile(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function createProfile(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceProfile.createProfile(payload);
      dispatch(setProfileResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function updateProfile(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceProfile.updateProfile(payload);
      dispatch(setProfileResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function deleteAccount() {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceProfile.deleteAccount();
      dispatch(setDeleteAccountResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}
